export default {
  TITLE: `Projet`,
  LIST: {
    TITLE: `Liste des projets`,
    SUMMARY: ``
  },
  CREATE_HEADER: {
    TITLE: `Créer un projet`,
    SUMMARY: ``
  },
  EDIT: {
    TITLE: `Modifier le projet`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `Détail du projet`,
    SUMMARY: ``
  },
  CREATE: `Créer un projet`,
  VIEW_PROJECT_TEMPLATES: `Voir les modèles d'horaire pour ce projet`,
  DELETE_BUTTON: {
    TITLE: `Supprimer un projet`,
    SUMMARY: `Êtes vous certain de vouloir supprimer ce projet?`,
    PRIMARY_ACTION: `Supprimer`
  },
  CODE: `Code`,
  STATUS: `Statut`,
  STATUSES: {
    CONFIRMED: `Confirmé`,
    TENTATIVE: `Provisoire`,
    CANCELLED: `Annulé`,
    PLACEHOLDER: `Remplissage (Placeholder)`,
    COMPLETED: `Terminé`,
    ARCHIVED: `Archivé`
  },
  NAME: 'Nom',
  TAGS: `Étiquettes`,
  NOTES: `Notes`,
  ADDITIONAL_INFO: `Informations complémentaires`,
  BILLING_DETAILS: `Facturation`,
  CLIENTS: `Clients`,
  DEFAULT_SHIFT_LENGTH: `Longueur de quart par défaut`,
  DEFAULT_START_TIME: `Heure de début de quart par défaut`,
  POSITIONS: `Positions`,
  PROJECT_OWNERS: `Responsables du projet`,
  LOCKED_USERS: `Utilisateurs verrouillés`,
  PREFERRED_USERS: `Utilisateurs préférés`,
  BLOCKED_USERS: `Utilisateurs bloqués`,
  ASSOCIATED_PROJECTS: `Projets associés`,
  REQUIRED_ATTRIBUTES: `Attributs requis`,
  PREFERRED_ATTRIBUTES: `Attributs préférés`,
  DEFAULTSHIFTTAGS: `Étiquettes de quart par défaut`,
  CUSTOM_FIELD_1: `Champ sur mesure 1`,
  csv: {
    NAME: `Nom du projet`,
    CODE: `Code du projet`,
    STATUS: `Statut`,
    DEFAULTSHIFTTAGS: `Étiquettes de quart par défaut`,
    TAGS: `Étiquettes`,
    CLIENTS: `Clients`,
    ASSOCIATEDPROJECTS: `Projets associés`,
    ADDITIONALINFO: `Informations complémentaires`,
    NOTES: `Notes`,
    REQUIREDATTRIBUTES: `Attributs requis`,
    PREFERREDATTRIBUTES: `Attributs préférés`,
    CSV_NAME: `export_liste_projets_{{ date }}`,
    START: `Début`,
    END: `Fin`
  },
  form: {
    ERRORS: {
      NAME_REQUIRED: `Le nom du projet est requis`,
      CODE_REQUIRED: `Le code du projet est requis`
    },
    EDIT: {
      TITLE: `Modification d'un projet`,
      SUMMARY: ``
    },
    CREATE: {
      TITLE: `Création d'un projet`,
      SUMMARY: ``
    },
    USER_RESTRICTIONS: `Utilisateurs restreints`,
    PROJECT_ATTRIBUTES: `Attributs du projet`,
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez un nom pour le projet`,
      DESCRIPTION: `Sert à identifier le projet`
    },
    CODE: {
      LABEL: `Code`,
      PLACEHOLDER: `Entrez un code pour le projet`,
      DESCRIPTION: `Sert à rapidement identifier les quarts de travail appartenant au projet dans l'horaire.`
    },
    CLIENTS: {
      LABEL: `Clients`,
      PLACEHOLDER: `Sélectionnez un ou plusieurs clients`,
      DESCRIPTION: `Sert à associer le projet à un ou plusieurs clients.`
    },
    CUSTOMFIELD1: {
      LABEL: `Champ sur mesure 1`,
      PLACEHOLDER: `Entrez une valeur pour le champ sur mesure`,
      DESCRIPTION: `Sert à associer le projet à des ressources externes lors des intégrations.`
    },
    DEFAULTSHIFTLENGTH: {
      LABEL: `Longueur de quart par défaut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à pré-remplir le champ de longueur de quart lors de la création de modèles d'horaire pour ce projet.`
    },
    DEFAULTSTARTTIME: {
      LABEL: `Début du quart par défaut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à pré-remplir le champ de début du quart lors de la création de modèles d'horaire pour ce projet.`
    },
    POSITIONS: {
      LABEL: `Positions`,
      PLACEHOLDER: `Ajoutez des positions à ce projet`,
      DESCRIPTION: `Sert à limiter les positions qui peuvent être vues lors de la modification de ces modèles d'horaire.`
    },
    PROJECTOWNERS: {
      LABEL: `Responsables du projet`,
      PLACEHOLDER: `Sélectionnez des responsables du projet`,
      DESCRIPTION: `Sert à associer des utilisateurs aux projets pour les filtrer dans l'horaire et ajouter de l'information aux courriels de notification.`
    },
    STATUS: {
      LABEL: `Statut`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à définir le statut actuel du projet.`
    },
    DEFAULTSHIFTTAGS: {
      LABEL: `Étiquettes de quart par défaut`,
      PLACEHOLDER: `Entrez une ou plusieurs étiquettes`,
      DESCRIPTION: `Lorsqu'un quart est assigné à ce projet, ces étiquettes seront ajoutées au quart par défaut. Les quarts de travail existants ne sont pas modifiés si ce champ change.`
    },
    TAGS: {
      LABEL: `Étiquettes`,
      PLACEHOLDER: `Entrez une ou plusieurs étiquettes`,
      DESCRIPTION: `Sert à entrer des informations sur mesure pour filtrer les quarts de travail à l'horaire.`
    },
    ADDITIONALINFO: {
      LABEL: `Informations complémentaires`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à ajouter plus de contexte lorsque des courriels de notification sont envoyés à propos de ce projet. Ce champ supporte les traductions en utilisant #en #fr.`
    },
    NOTES: {
      LABEL: `Notes`,
      PLACEHOLDER: `Entrez des notes sur le projet`,
      DESCRIPTION: `Sert à garder des informations qui ne seront pas transmises dans le projet.`
    },
    LOCKEDUSERS: {
      LABEL: `Utilisateurs verrouillés`,
      PLACEHOLDER: `Sélectionnez des employés à verrouiller`,
      DESCRIPTION: `Sert à empêcher les utilisateurs verrouillés d'être assignés à d'autres projets.`
    },
    PREFERREDUSERS: {
      LABEL: `Utilisateurs préférés`,
      PLACEHOLDER: `Sélectionnez des utilisateurs à préférer`,
      DESCRIPTION: `Sert à indiquer qu'un utilisateur est préféré sur un projet lors de l'assignation à l'horaire, n'empêche pas d'assigner l'utilisateur.`
    },
    BLOCKEDUSERS: {
      LABEL: `Utilisateurs bloqués`,
      PLACEHOLDER: `Sélectionnez des utilisateurs à bloquer`,
      DESCRIPTION: `Sert à empêcher des utilisateurs d'être assignés au projet`
    },
    ASSOCIATEDPROJECTS: {
      LABEL: `Projets associés`,
      PLACEHOLDER: `Sélectionnez des projets à associer`,
      DESCRIPTION: `Sert à comptabiliser l'expérience sur d'autres projets lors de l'assignation à l'horaire.`
    },
    REQUIREDATTRIBUTES: {
      TITLE: `Attributs requis`,
      DESCRIPTION: `Sert à empêcher des utilisateurs d'être assignés au projet s'ils ne possèdent pas les attributs requis.`
    },
    PREFERREDATTRIBUTES: {
      TITLE: `Attributs préférés`,
      DESCRIPTION: `Sert à ordonner les utilisateurs lors de l'assignation à l'horaire.`
    },
    ALREADY_IN_USE: {
      PROJECT_CODE: `Le code de projet est déjà utilisé.`
    },
    CREATE_CLIENT_MODAL: {
      TITLE: `Créer une nouvelle étiquette de client`,
      SUMMARY: ``
    }
  },
  IMPORT_PROJECTS: `Importer des projets`,
  import: {
    LINE: `Ligne`,
    VALIDATION: `Validation`,
    NAME: `Nom`,
    NAME_DESC: `Le nom du projet`,
    STATUS: `Statut`,
    STATUS_DESC: `Le statut du projet doit être un des suivants: <1>CONFIRMED, TENTATIVE, CANCELLED, PLACEHOLDER, COMPLETED</1>`,
    CODE: `Code`,
    CODE_DESC: `Le code doit être unique`,
    START: `Début`,
    START_DESC: ` La date de début doit être inscrite dans le format <1>YYYY-MM-DD</1>, par exemple <1>2010-01-30</1> pour le 30 Janvier 2010.`,
    END: `Fin`,
    END_DESC: `La date de fin doit être dans le même format que celle du début.`,
    DEPARTMENTS: `Départements`,
    DEPARTMENTS_DESC: `Doit être une liste de codes d'import de départments existants. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    POSITIONS: `Positions`,
    POSITIONS_DESC: `Doit être une liste de codes d'import de départments existants. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    PROJECTOWNERS: `Responsables de projet`,
    PROJECTOWNERS_DESC: `Doit être une liste de numéros d'employé valides. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    TAGS: `Étiquettes`,
    TAGS_DESC: `Champ d'étiquette libre. Pour entrer plusieurs valeurs, laissez un espace entre chaque étiquette`,
    DEFAULTSHIFTTAGS: `Étiquettes de quart par défaut`,
    DEFAULTSHIFTTAGS_DESC: `Doit être une liste de codes d'import de départments existants. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    ADDITIONALINFO: `Informations supplémentaires`,
    ADDITIONALINFO_DESC: `Champ de texte libre destiné aux notes visibles pour les employés`,
    NOTES: `Notes`,
    NOTES_DESC: `Champ de texte libre destiné aux notes internes`,
    LOCKEDUSERS: `Utilisateurs vérouillés`,
    LOCKEDUSERS_DESC: `Doit être une liste de numéros d'employé valides. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    PREFERREDUSERS: `Utilisateurs préférés`,
    PREFERREDUSERS_DESC: `Doit être une liste de numéros d'employé valides. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    BLOCKEDUSERS: `Utilisateurs bloqués`,
    BLOCKEDUSERS_DESC: `Doit être une liste de numéros d'employé valides. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    REQUIREDATTRIBUTES: `Attributs requis`,
    REQUIREDATTRIBUTES_DESC: `Doit être une liste de codes d'import de départments existants. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    PREFERREDATTRIBUTES: `Attributs préférés`,
    PREFERREDATTRIBUTES_DESC: `Doit être une liste de codes d'import de départments existants. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    TITLE: {
      TITLE: `Importer des projects`,
      SUMMARY: ``
    },
    MISSING_HEADERS: `Entête manquant : <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Entêtes manquants : <0>{{value}}</0>`,
    MANDATORY_FIELDS: `Champs requis`,
    OPTIONAL_FIELDS: `Champs optionnels`,
    NOT_VALID: `Il y a <0>{{count}}</0> projet invalide.`,
    NOT_VALID_other: `Il y a <0>{{count}}</0> projets invalides.`,
    SAVE_FAILED: `Il y a <0>{{count}}</0> projet qui n'a pas été sauvegardé.`,
    SAVE_FAILED_other: `Il y a <0>{{count}}</0> projets qui n'ont pas été sauvegardés.`,
    ERROR_READING_CSV: `Le fichier importé ne respecte pas le format CSV. Si votre excel est en français, veuillez aller changer le délimiteur par défaut dans vos paramètres.`,
    TEMPLATE_FILE_NAME: `importation_projets`,
    DOWNLOAD_TEMPLATE: `Télécharger un modèle de fichier`
  }
}
